import { useNumberParserFromIntlNumberFormatOptions, } from "@plansoft-configuration-renderer/utils";
import { useConfigurationLanguage } from "./useConfigurationLanguage";
/**
 * Returns a function for parsing numbers, using the current configuration language
 * @category Hook
 * @see https://stackoverflow.com/a/29273131
 * @param options
 * @returns the number parser function
 */
export function useNumberParser(options) {
    const localeCode = useConfigurationLanguage();
    // return a memoized function for parsing numbers
    return useNumberParserFromIntlNumberFormatOptions(localeCode, options);
}
//# sourceMappingURL=useNumberParser.js.map